import {useState, SyntheticEvent } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Button, IconButton, Tab, Tabs } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useMap } from 'react-leaflet';
import { useRoadFeatureResponse, useRouteStoreActions } from '../../../stores/RouteStore';
import { RoadFeatureService} from '../../../services/RuteplanAPI';
import RoadFeatureApiTextField from "./RoadFeatureApiTextField";
import RoadFeatureResponseList from './RoadFeatureResponseList';
import RoadFeatureResponseWithBruksklasseList from './RoadFeatureResponseWithBruksklasseList';
import { useRouteFeatureDialogStoreActions } from '../../../stores/RouteFeatureDialogStore';

export interface IRoadFeatureApiControlsProps {
    setDisableDragging: (disableDragging: boolean) => void;
    roadFeatureRequest: string;
    setRoadFeatureRequest: (value: string) => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
}


export default function RoadFeatureApiControls(props: IRoadFeatureApiControlsProps) {
  const [tab, setTab] = useState(0);
  const map = useMap();  
  const routeStore = useRouteStoreActions();
  const roadFeatureResponse = useRoadFeatureResponse();
  const { setClickedRoadFeature, setRoadFeatureDialogIsOpen} = useRouteFeatureDialogStoreActions();

  const onRoadFeatureClick = (feature: any, event: React.MouseEvent) => { 
        event.stopPropagation(); 
        setClickedRoadFeature(feature);
        setRoadFeatureDialogIsOpen(true);        
    }

  const onLukkClick = () => {
        map.doubleClickZoom.enable();
        map.scrollWheelZoom.enable();
        routeStore.setControlsOpen(false);
  }

  const sendRequest = async () => {
    const request = JSON.parse(props.roadFeatureRequest);
    let response;

    if(props.roadFeatureRequest.includes("bruksklasseType")) {
      response = await RoadFeatureService.roadFeatureGetRoadFeaturesWithBruksklasse({roadFeatureRequest: request});
      setTab(1);
    } else {
      response = await RoadFeatureService.roadFeatureGetRoadFeatures({roadFeatureRequest: request});
      setTab(1);
    }
    
    routeStore.setRoadFeatureResponse(response);
  }

  const onMouseEnterTextArea = () => {
    props.onMouseEnter();
    props.setDisableDragging(true);
  }

  const onMouseLeaveTextArea = () => {
    props.onMouseLeave();
    props.setDisableDragging(false);
  }

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box 
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
    height={'90%'} 
    width={'98%'} 
    sx={{
      flexGrow: 1, 
      justifyContent: 'center', 
    }}>
      <Grid 
      container 
      spacing={2}
      height={'90%'} 
      width={'100%'}
      >
        <Grid height={'10%'} item md={12}>
          <div
          style={{
              height: '100%',
              width: '100%',
              flexDirection: 'row',
              display: 'flex'
          }}>
            <div
            style={{
            width: '100%',
            textAlign: 'right'
            }}
            >
            </div>
              <IconButton
                onClick={onLukkClick} 
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
                >
                  <CloseIcon
                  sx={{color: 'red'}}
                  fontSize='large'
                  />
                </IconButton>
          </div>
        </Grid>

        <Grid height={'90%'} item md={4}>
          <Box 
          sx={{
            width: '100%', 
            height: '100%', 
            overflowY: 'auto', 
            border: 'groove',
            borderRadius: '5px'
            }}>
              {props.roadFeatureRequest.includes("bruksklasseType") ?
                <RoadFeatureResponseWithBruksklasseList
                roadFeatureResponse={roadFeatureResponse}
                onClick={onRoadFeatureClick}
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
                />
              :
                <RoadFeatureResponseList
                roadFeatureResponse={roadFeatureResponse}
                onClick={onRoadFeatureClick}
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
                />
              } 
          </Box>
        </Grid>
        <Grid height={'90%'} item md={8}>
            <Box
            sx={{
              height: '100%',
              width: '100%',
              border: 'groove',
              borderRadius: '5px'
            }}
            >
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={handleChange} aria-label="tabs">
                  <Tab label="Request" />
                  <Tab label="Response" />
                </Tabs>
              </Box>
              <RoadFeaturesApiControlsTabPanel
              value={tab} 
              index={0}
              width={'99%'} 
              height={'99%'}
               >
                <RoadFeatureApiTextField
                  isRequest={true}
                  roadFeatureRequest={props.roadFeatureRequest}
                  setRoadFeatureRequest={props.setRoadFeatureRequest}
                  onMouseEnterTextArea={onMouseEnterTextArea}
                  onMouseLeaveTextArea={onMouseLeaveTextArea}
                />
              </RoadFeaturesApiControlsTabPanel>
              <RoadFeaturesApiControlsTabPanel
              value={tab}
              index={1}
              width={'99%'} 
              height={'99%'}
                >
                  <RoadFeatureApiTextField
                  isRequest={false}
                  roadFeatureRequest={props.roadFeatureRequest}
                  setRoadFeatureRequest={props.setRoadFeatureRequest}
                  roadFeatureResponse={roadFeatureResponse}
                  onMouseEnterTextArea={onMouseEnterTextArea}
                  onMouseLeaveTextArea={onMouseLeaveTextArea}
                  />
              </RoadFeaturesApiControlsTabPanel>
            </Box>
        </Grid>
      </Grid>
      <div
      style={{
          height: '10%',
          width: '100%',
          textAlign: 'center',
          flexDirection: 'row',
          display: 'flex'
      }}
      >
          <div
          style={{
          width: '85%',
          }}
          >
          </div>
          
          <div
          style={{
          width: '15%',
          textAlign: 'right',
          alignContent: 'center'
          }}
          >
              <Button
              variant='contained'
              color='success'
              onClick={sendRequest} 
              onMouseEnter={props.onMouseEnter}
              onMouseLeave={props.onMouseLeave}
              >
                  Send Request
              </Button>
          </div>
      </div>
    </Box>
  );
}


interface IRoadFeaturesApiControlsTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  height: string;
  width: string;
}

function RoadFeaturesApiControlsTabPanel(props: IRoadFeaturesApiControlsTabPanelProps) {
  const { children, value, index, height, width, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`roadFeatures-tabpanel-${index}`}
      aria-labelledby={`roadFeatures-tab-${index}`}
      {...other}
      style={{
        height: '95%',
        width: '100%',
        borderRadius: '5px'
      }}

    >
      {value === index && <Box sx={{ height: height, width: width }}>{children}</Box>}
    </div>
  );
}





